/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Card, Button, Modal, Table } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { format } from "date-fns";
import { it } from "date-fns/locale";

import * as apiArticoliEvento from "../../api/articoliEvento";
import { roles } from "../../config/config";

export const CampioniEventi = () => {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  const isManager = role === roles.admin || role === roles.gestore || role === roles.developer;
  
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [modalItems, setModalItems] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const data = await apiArticoliEvento.getArticoliEvento(user.authToken);
      setRows(data || []);
    } catch (e) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const openDetail = async (row) => {
    setModalData(row);
    setShowModal(true);
    setModalLoading(true);
    try {
      const items = await apiArticoliEvento.getArticoliEventoByRichiesta(user.authToken, row.idRichiesta);
      setModalItems(items || []);
    } catch (e) {
      setModalItems([]);
    } finally {
      setModalLoading(false);
    }
  };

  const formatDate = (d) => {
    if (!d) return "-";
    try {
      return format(new Date(d), "dd/MM/yyyy", { locale: it });
    } catch {
      return d;
    }
  };

  const quantitaConDettagli = (item) => {
    const parts = [];
    if (item.lotto) parts.push(`Lot. ${item.lotto}`);
    const scadenza = apiArticoliEvento.formatMonthExpiry(item.data_scadenza);
    if (scadenza !== "-") parts.push(`scad. ${scadenza}`);
    return parts.length > 0 ? `${item.quantita} (${parts.join(" ")})` : item.quantita;
  };

  return (
    <>
      <Card className="card-custom gutter-b">
        <Card.Header className="border-0 py-5">
          <Card.Title>
            <h3 className="card-label font-weight-bolder text-dark">Campioni Eventi</h3>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">Articoli assegnati per richieste Stand</span>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="table-responsive">
            <Table className="table table-head-custom table-vertical-center">
              <thead>
                <tr className="text-left">
                  <th>Evento</th>
                  <th>Agente</th>
                  <th>Data evento</th>
                  <th>Data richiesta</th>
                  <th>Riepilogo materiali</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {!loading && rows.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">Nessun articolo assegnato</td>
                  </tr>
                )}
                {rows.map((row) => (
                  <tr key={row.idRichiesta}>
                    <td>
                      <div className="font-weight-bolder">{row.titoloEvento || "-"}</div>
                      <div className="text-muted font-size-sm">{row.sede || ""}</div>
                    </td>
                    <td>{row.agenteFullname || "-"}</td>
                    <td>
                      {row.dataInizio || row.dataFine
                        ? `dal ${formatDate(row.dataInizio)} al ${formatDate(row.dataFine)}`
                        : "-"}
                    </td>
                    <td>{formatDate(row.richiestaDateCreated)}</td>
                    <td>
                      <span className="label label-light-primary label-inline">
                        {row.articoli ? row.articoli.length : 0} articolo/i
                      </span>
                    </td>
                    <td>
                      <Button variant="light-primary" size="sm" onClick={() => openDetail(row)}>
                        Dettaglio
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Dettaglio articoli evento
            {modalData && (
              <div className="text-muted font-size-sm mt-1">
                {modalData.titoloEvento} {modalData.sede ? `- ${modalData.sede}` : ""}
              </div>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalLoading ? (
            <div className="text-center p-4">Caricamento...</div>
          ) : (
            <div className="table-responsive">
              <Table className="table table-head-custom table-vertical-center">
                <thead>
                  <tr className="text-left">
                    <th>SKU</th>
                    <th>Nome</th>
                    <th>Tipo</th>
                    <th>Quantità</th>
                    <th>Note</th>
                    <th>Assegnato da</th>
                  </tr>
                </thead>
                <tbody>
                  {modalItems.length === 0 && (
                    <tr>
                      <td colSpan="6" className="text-center text-muted">Nessun articolo</td>
                    </tr>
                  )}
                  {modalItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.sku}</td>
                      <td>{item.nomeArticolo || "-"}</td>
                      <td>{apiArticoliEvento.formatTipoArticolo(item.tipoArticolo)}</td>
                      <td>{quantitaConDettagli(item)}</td>
                      <td>{item.note || "-"}</td>
                      <td>{item.utenteAssegnato || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
